import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { string_type, class_type, record_type, lambda_type, unit_type, union_type, bool_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { op_PlusPlus } from "../fable_modules/Feliz.DaisyUI.5.0.0/Operators.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { icon } from "./Icon.js";
import info from "@iconify-icons/fa6-solid/info";
import circle_check from "@iconify-icons/fa6-solid/circle-check";
import circle_xmark from "@iconify-icons/fa6-solid/circle-xmark";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import magnifying_glass from "@iconify-icons/fa6-solid/magnifying-glass";
import { TranslationPages_Home__get_Clear, TranslationPages_Home__get_SearchOrAdd, AppTranslations__get_Home, TranslationPages_Home__get_Search } from "../Shopfoo.Shared/Translations.js";
import xmark from "@iconify-icons/fa6-solid/xmark";

export class AfterSearch extends Union {
    constructor(shouldClearTerm) {
        super();
        this.tag = 0;
        this.fields = [shouldClearTerm];
    }
    cases() {
        return ["AfterSearch"];
    }
}

export function AfterSearch_$reflection() {
    return union_type("Shopfoo.Client.Components.AfterSearch", [], AfterSearch, () => [[["shouldClearTerm", bool_type]]]);
}

class AfterSearchCallbacks extends Record {
    constructor(ClearTerm) {
        super();
        this.ClearTerm = ClearTerm;
    }
}

function AfterSearchCallbacks_$reflection() {
    return record_type("Shopfoo.Client.Components.AfterSearchCallbacks", [], AfterSearchCallbacks, () => [["ClearTerm", lambda_type(unit_type, unit_type)]]);
}

class SearchRunner {
    constructor(afterSearch) {
        this.afterSearch = afterSearch;
    }
}

function SearchRunner_$reflection() {
    return class_type("Shopfoo.Client.Components.SearchRunner", undefined, SearchRunner);
}

function SearchRunner_$ctor_Z7FE72FA4(afterSearch) {
    return new SearchRunner(afterSearch);
}

function SearchRunner__Run_Z65075A34(_, onSearch) {
    if (onSearch().fields[0]) {
        _.afterSearch.ClearTerm();
    }
}

export class SearchCompletionStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Success", "Info", "Error"];
    }
}

export function SearchCompletionStatus_$reflection() {
    return union_type("Shopfoo.Client.Components.SearchCompletionStatus", [], SearchCompletionStatus, () => [[], [["message", string_type]], [["message", string_type]]]);
}

export class SearchButtonProps extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["None", "Active", "Searching", "SearchComplete"];
    }
}

export function SearchButtonProps_$reflection() {
    return union_type("Shopfoo.Client.Components.SearchButtonProps", [], SearchButtonProps, () => [[], [["icon", class_type("Glutinum.Iconify.IconifyIcon", undefined, IconifyIcon)], ["tooltip", string_type], ["onSearch", lambda_type(unit_type, AfterSearch_$reflection())]], [], [["status", SearchCompletionStatus_$reflection()]]]);
}

function SearchBox_searchButton_Z25D6ACCD(key, props, search) {
    if (props.tag === 0) {
        return defaultOf();
    }
    else {
        return createElement("button", createObj(Helpers_combineClasses("btn", toList(delay(() => append(singleton(op_PlusPlus(op_PlusPlus(["className", "btn-ghost"], ["className", "btn-circle"]), ["className", "btn-sm"])), delay(() => append(singleton(["key", `search-input-button-${key}`]), delay(() => append(singleton(["type", "button"]), delay(() => append(singleton(["onMouseDown", (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
        }]), delay(() => {
            let elems_1;
            const matchValue = props;
            switch (matchValue.tag) {
                case 2:
                    return singleton((elems_1 = [createElement("span", createObj(Helpers_combineClasses("loading", ofArray([["className", "loading-spinner"], ["className", "loading-xs"], ["key", `search-input-${key}-spinner`]]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
                case 3:
                    return (matchValue.fields[0].tag === 1) ? append(singleton(["title", matchValue.fields[0].fields[0]]), delay(() => append(singleton(["className", "text-info"]), delay(() => {
                        let elems_3;
                        return singleton((elems_3 = [icon(info)], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
                    })))) : ((matchValue.fields[0].tag === 0) ? append(singleton(["className", "text-success"]), delay(() => {
                        let elems_4;
                        return singleton((elems_4 = [icon(circle_check)], ["children", reactApi.Children.toArray(Array.from(elems_4))]));
                    })) : append(singleton(["title", matchValue.fields[0].fields[0]]), delay(() => append(singleton(["className", "text-error"]), delay(() => {
                        let elems_2;
                        return singleton((elems_2 = [icon(circle_xmark)], ["children", reactApi.Children.toArray(Array.from(elems_2))]));
                    })))));
                case 0: {
                    return empty();
                }
                default:
                    return append(singleton(["title", matchValue.fields[1]]), delay(() => append(singleton(["onClick", (ev_1) => {
                        ev_1.preventDefault();
                        ev_1.stopPropagation();
                        SearchRunner__Run_Z65075A34(search, matchValue.fields[2]);
                    }]), delay(() => {
                        let elems;
                        return singleton((elems = [icon(matchValue.fields[0])], ["children", reactApi.Children.toArray(Array.from(elems))]));
                    }))));
            }
        })))))))))))));
    }
}

export function SearchBox_SearchBox_3A9FAC5(searchBox_SearchBox_3A9FAC5InputProps) {
    let elems_1;
    const className = searchBox_SearchBox_3A9FAC5InputProps.className;
    const searchMoreButtonProps = searchBox_SearchBox_3A9FAC5InputProps.searchMoreButtonProps;
    const onKeyDown = searchBox_SearchBox_3A9FAC5InputProps.onKeyDown;
    const inputRef = searchBox_SearchBox_3A9FAC5InputProps.inputRef;
    const translations = searchBox_SearchBox_3A9FAC5InputProps.translations;
    const onChange = searchBox_SearchBox_3A9FAC5InputProps.onChange;
    const value = searchBox_SearchBox_3A9FAC5InputProps.value;
    const key = searchBox_SearchBox_3A9FAC5InputProps.$key;
    const clearSearchTerm = () => {
        onChange("");
    };
    const searchRunner = SearchRunner_$ctor_Z7FE72FA4(new AfterSearchCallbacks(clearSearchTerm));
    return createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", key], ["className", join(" ", toList(delay(() => append(singleton("input input-bordered flex items-center gap-2"), delay(() => {
        const matchValue = className;
        return (matchValue == null) ? singleton("w-full") : singleton(matchValue);
    })))))], (elems_1 = toList(delay(() => append(singleton(icon(magnifying_glass)), delay(() => append(singleton(createElement("input", createObj(toList(delay(() => append(singleton(["key", `${key}-input`]), delay(() => append(singleton(["type", "text"]), delay(() => append(singleton(["className", "grow bg-transparent outline-none"]), delay(() => append(singleton(["value", value]), delay(() => append(singleton(["onChange", (ev) => {
        onChange(ev.target.value);
    }]), delay(() => append((searchMoreButtonProps == null) ? singleton(["placeholder", TranslationPages_Home__get_Search(AppTranslations__get_Home(translations))]) : singleton(["placeholder", TranslationPages_Home__get_SearchOrAdd(AppTranslations__get_Home(translations))]), delay(() => {
        let matchValue_2;
        return append((matchValue_2 = inputRef, (matchValue_2 == null) ? (empty()) : singleton(["ref", matchValue_2])), delay(() => {
            const matchValue_3 = onKeyDown;
            if (matchValue_3 == null) {
                return empty();
            }
            else {
                return singleton(["onKeyDown", matchValue_3]);
            }
        }));
    }))))))))))))))))), delay(() => {
        let matchValue_4;
        return append((matchValue_4 = searchMoreButtonProps, (matchValue_4 == null) ? (empty()) : singleton(SearchBox_searchButton_Z25D6ACCD(`${key}-search-more-btn`, matchValue_4, searchRunner))), delay(() => {
            let elems;
            return (value !== "") ? singleton(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([op_PlusPlus(op_PlusPlus(["className", "btn-ghost"], ["className", "btn-circle"]), ["className", "btn-sm"]), ["key", `${key}-clear-btn`], ["type", "button"], ["title", TranslationPages_Home__get_Clear(AppTranslations__get_Home(translations))], ["onClick", (_arg) => {
                clearSearchTerm();
            }], ["onMouseDown", (ev_1) => {
                ev_1.preventDefault();
                ev_1.stopPropagation();
            }], (elems = [icon(xmark)], ["children", reactApi.Children.toArray(Array.from(elems))])]))))) : empty();
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
}

